import React from 'react';
export const Footer = () => {
  return <footer className="bg-white text-zinc-800 py-16 border-t border-zinc-200" data-id="element-55">
      <div className="container-custom" data-id="element-56">
        <div className="flex flex-col md:flex-row justify-between mb-12" data-id="element-57">
          <div className="mb-8 md:mb-0" data-id="element-58">
            <div className="flex items-center mb-4" data-id="element-59">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/5cs2ZPr2zzBNwQq8qpJfb2/Messages_Improved_Teal.png" alt="Messages Improved Consulting Logo" className="h-8 mr-3" data-id="element-60" />
              <div className="flex items-center" data-id="element-61">
                <span className="font-orbitron tracking-[0.1em] font-light text-xl text-zinc-800" data-id="element-62">
                  Messages Improved
                </span>
                <span className="font-orbitron tracking-[0.1em] font-light text-xl text-teal-dark ml-2" data-id="element-63">
                  CONSULTING
                </span>
              </div>
            </div>
            <p className="text-zinc-600 max-w-md" data-id="element-64">
              A full service AI product development agency that makes AI dreams
              a reality.
            </p>
          </div>
          <div className="grid grid-cols-2 md:grid-cols-3 gap-8" data-id="element-65">
            <div data-id="element-66">
              <h3 className="font-serif text-lg mb-4 text-zinc-900" data-id="element-67">
                Services
              </h3>
              <ul className="space-y-2 text-zinc-600" data-id="element-68">
                <li data-id="element-69">
                  <a href="#services" className="hover:text-teal-dark transition-colors" data-id="element-70">
                    Build Package
                  </a>
                </li>
                <li data-id="element-71">
                  <a href="#services" className="hover:text-teal-dark transition-colors" data-id="element-72">
                    Consulting Package
                  </a>
                </li>
                <li data-id="element-73">
                  <a href="#services" className="hover:text-teal-dark transition-colors" data-id="element-74">
                    DIY AI Agent
                  </a>
                </li>
              </ul>
            </div>
            <div data-id="element-75">
              <h3 className="font-serif text-lg mb-4 text-zinc-900" data-id="element-76">Company</h3>
              <ul className="space-y-2 text-zinc-600" data-id="element-77">
                <li data-id="element-78">
                  <a href="#case-studies" className="hover:text-teal-dark transition-colors" data-id="element-79">
                    Case Studies
                  </a>
                </li>
                <li data-id="element-80">
                  <a href="#why-different" className="hover:text-teal-dark transition-colors" data-id="element-81">
                    About Us
                  </a>
                </li>
                <li data-id="element-82">
                  <a href="#client-profile" className="hover:text-teal-dark transition-colors" data-id="element-83">
                    Who We Serve
                  </a>
                </li>
              </ul>
            </div>
            <div data-id="element-84">
              <h3 className="font-serif text-lg mb-4 text-zinc-900" data-id="element-85">Contact</h3>
              <ul className="space-y-2 text-zinc-600" data-id="element-86">
                <li data-id="element-87">
                  <a href="http://calendly.com/es-lee" target="_blank" rel="noopener noreferrer" className="hover:text-teal-dark transition-colors" data-id="element-88">
                    Book a Consultation
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div className="border-t border-zinc-200 pt-8 text-zinc-500 text-sm flex flex-col md:flex-row justify-between items-center" data-id="element-89">
          <div data-id="element-90">
            &copy; {new Date().getFullYear()} Messages Improved Consulting. All
            rights reserved.
          </div>
          <div className="mt-4 md:mt-0" data-id="element-91">
            <ul className="flex space-x-6" data-id="element-92">
              <li data-id="element-93">
                <a href="#" className="hover:text-teal-dark transition-colors" data-id="element-94">
                  Privacy Policy
                </a>
              </li>
              <li data-id="element-95">
                <a href="#" className="hover:text-teal-dark transition-colors" data-id="element-96">
                  Terms of Service
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </footer>;
};